import useUpdateShopifyPreferenceNotifications from "@babackapp/private-api-client/client/use-update-shopify-preference-notifications";
import { Card, CardContent } from "@babackapp/ui/components/card";
import { Separator } from "@babackapp/ui/components/separator";
import { useState } from "react";
import {
  ShopifyNotificationsFormValues,
  ShopifyPreferencesNotificationsForm,
} from "./shopify-preferences-notifications-form";
import {
  ReturnEmailConfigs,
  ReturnEmailTemplatesSettings,
} from "./return-email-templates-settings";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

export default function CustomerPortalNotificationsCard() {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: updateShopifyPreferenceNotifications } =
    useUpdateShopifyPreferenceNotifications(shop);

  const [returnEmailConfigs, setReturnEmailConfigs] =
    useState<ReturnEmailConfigs>(
      shop?.preferences?.notifications?.returnEmailConfigs ?? {},
    );

  if (!shop) {
    return null;
  }

  const onSubmitShopifyNotifications = (
    data: ShopifyNotificationsFormValues,
  ) => {
    return updateShopifyPreferenceNotifications({
      emails: data.emails,
      shopifyEmails: {
        refundEmail: data.refundEmail,
        labelEmail: data.labelEmail,
        giftCardEmail: data.giftCardEmail,
        storeCreditEmail: data.storeCreditEmail,
      },
    });
  };

  const onReturnEmailConfigsChange = (configs: ReturnEmailConfigs) => {
    setReturnEmailConfigs(configs);
    void updateShopifyPreferenceNotifications({ returnEmailConfigs: configs });
  };

  return (
    <Card className="w-full">
      <CardContent>
        <ShopifyPreferencesNotificationsForm
          isGiftCardMode={shop.discount.giftCard === "giftCard"}
          isStoreCreditMode={shop.discount.giftCard === "storeCredit"}
          onSubmit={onSubmitShopifyNotifications}
          defaultValues={{
            emails: shop.preferences.notifications.emails,
            refundEmail:
              shop.preferences.notifications.shopifyEmails.refundEmail,
            labelEmail: shop.preferences.notifications.shopifyEmails.labelEmail,
            // Absent on shops predating the toggle: the switch must show as on.
            giftCardEmail:
              shop.preferences.notifications.shopifyEmails.giftCardEmail ??
              true,
            // Absent on shops predating the toggle: the switch must show as
            // off — Shopify never sent that email before.
            storeCreditEmail:
              shop.preferences.notifications.shopifyEmails.storeCreditEmail ??
              false,
          }}
        />
        <Separator className="my-8" />
        <ReturnEmailTemplatesSettings
          value={returnEmailConfigs}
          onChange={onReturnEmailConfigsChange}
          onGenerated={setReturnEmailConfigs}
        />
      </CardContent>
    </Card>
  );
}
